import React from 'react';
import { Card, Row, Col, Typography, Space, Flex, Steps } from 'antd';
import { 
  ShoppingOutlined, 
  GiftOutlined, 
  CreditCardOutlined, 
  CheckCircleOutlined,
  MobileOutlined
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import PageLayout from '../../components/PageLayout';
import './DepositGuidePage.css';

const { Title, Text, Paragraph } = Typography;
const { Step } = Steps;

const DepositGuidePage: React.FC = () => {
  const { t } = useTranslation();

  const steps = [
    {
      title: t('depositGuide.step1Title'),
      description: t('depositGuide.step1Description'),
      icon: <ShoppingOutlined />,
    },
    {
      title: t('depositGuide.step2Title'),
      description: t('depositGuide.step2Description'),
      icon: <GiftOutlined />,
    },
    {
      title: t('depositGuide.step3Title'),
      description: t('depositGuide.step3Description'),
      icon: <CreditCardOutlined />,
    },
    {
      title: t('depositGuide.step4Title'),
      description: t('depositGuide.step4Description'),
      icon: <CheckCircleOutlined />,
    },
    {
      title: t('depositGuide.step5Title'),
      description: t('depositGuide.step5Description'),
      icon: <MobileOutlined />,
    },
  ];

  return (
    <PageLayout className="deposit-guide-page">
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Flex justify="center">
          <Title level={2} className="guide-title">
            {t('depositGuide.title')}
          </Title>
        </Flex>

        <Row gutter={[24, 24]} justify="center">
          <Col xs={24} sm={24} md={22} lg={20} xl={18}>
            <Card className="guide-card">
              <Space direction="vertical" size="large" style={{ width: '100%' }}>
                <Paragraph className="guide-intro">
                  {t('depositGuide.intro')}
                </Paragraph>

                <Steps
                  direction="vertical"
                  current={-1}
                  items={steps.map((step, index) => ({
                    title: (
                      <Text strong className="step-title">
                        {step.title}
                      </Text>
                    ),
                    description: (
                      <Text className="step-description">
                        {step.description}
                      </Text>
                    ),
                    icon: <div className="step-icon-wrapper">{step.icon}</div>,
                  }))}
                  className="guide-steps"
                />
              </Space>
            </Card>
          </Col>
        </Row>
      </Space>
    </PageLayout>
  );
};

export default DepositGuidePage;

